import React, { Component } from 'react'
import axios from "axios";
import "../css/general-style.css"
import '../css/table-responsive.css'
import { getValueCookie } from '../services/cookieService'
import server from "../services/Connection/backEndLink";
import LoadingWindow from '../components/LoadingWindow';
import { MdEdit } from "react-icons/md";
import { AiOutlineEye } from "react-icons/ai";
import { IoSearch } from "react-icons/io5";

// Menu
import { Menu } from "../components/Menu/Menu";

export default class CustomerList extends Component {
    constructor(props) {
        super(props)
        this.ModalLoading = React.createRef();
    }

    state = {
        Customers: [],
        FilteredCustomers: [],
        SearchTerm: ""
    }

    componentDidMount(){
        this.getCustomerList()
    }

    async getCustomerList() {
        let salesPerson = getValueCookie('SalesPerson');
        let company = getValueCookie('CompanyId')
        let responseBack

        if(salesPerson === 'JC' || salesPerson === 'KL2'){
            salesPerson = '0000'
        }
        const payload = {
            data: {
                SalespersonNo: salesPerson,
                idCompany: Number(company)
            }
        }

        const query = "/customer/getList"
            await axios.post(`${server.url}${query}`, payload).then(
                response => {
                    responseBack = response.data
                }
            ).catch(error => {
                console.log(error)
                // confirmCloseAlert('incorrect', 'Error in the Server Response: ' + error)
            })

        this.setState({Customers: responseBack.data, FilteredCustomers: responseBack.data})
    }

    handleSearchChange = (e) => {
        this.setState({ SearchTerm: e.target.value });
    };

    filterCustomer = () => {
        const { SearchTerm, Customers } = this.state;
        const lowerSearch = (SearchTerm || '').toLowerCase();

        const filtered = Customers.filter(customer => {
            const customerNo = customer.CustomerNo ? customer.CustomerNo.toLowerCase() : '';
            const customerName = customer.CustomerName ? customer.CustomerName.toLowerCase() : '';

            return customerNo.includes(lowerSearch) || customerName.includes(lowerSearch);
        });

        this.setState({ FilteredCustomers: filtered });
    }
    handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            this.filterCustomer();
        }
    }

    handleSearchButtonClick = () => {
        this.filterCustomer();
    }

    handleGoToCustomer = (customer) => {
        localStorage.setItem('selectedCustomer', JSON.stringify(customer));

        window.location.href = `/show-customer/${customer.CustomerNo}`;
    };


    render() {
        let { SearchTerm, FilteredCustomers } = this.state;
        FilteredCustomers = this.state.FilteredCustomers.slice(0, 20);
        return (
            <div>
                {/* Main menu */}
                <Menu Refresh={this.state.Refresh} Father={this} />
                <LoadingWindow ref={this.ModalLoading} />
                <div className='text-center my-4'>
                    <h2 className='display-4 fw-bold inventory-title'>Customer List</h2>
                    <p className='lead text-muted inventory-subtitle'>To start please search or select a customer</p>
                </div>
                <div className=' col-sm-12 row d-flex justify-content-center'>
                    <div className='col-4'>
                        <input className='form-control display-inline' placeholder='Search customer' autoComplete="off" value={SearchTerm} onChange={this.handleSearchChange} onKeyDown={this.handleKeyPress} />
                    </div>
                    <div className='col-auto'>
                        <button className="btn blueButton" onClick={this.handleSearchButtonClick}><IoSearch /></button>
                    </div>
                </div>
                <div className='row pb-2'>
                    <div className='col-sm-12'>
                        <div className='tableFixHead tb-1'>
                            <table className='table table-striped align-middle table-hover'>
                                <thead>
                                    <tr className='text-center'>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Customer No
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Name
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Address Line
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                City
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Price Level
                                            </div>
                                        </th>
                                        <th>
                                            <div className='d-flex justify-content-center align-items-center'>
                                                Actions
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        FilteredCustomers.map((customer, i) => (
                                            <tr key={i}>
                                                <td>{customer.CustomerNo}</td>
                                                <td className='text-start'>{customer.CustomerName}</td>
                                                <td className='text-start'>{customer.AddressLine1}</td>
                                                <td className='text-center'>{customer.City}</td>
                                                <td className='text-center'>{customer.PriceLevel}</td>
                                                <td className='text-center'><button className='btn greenButton' onClick={() => this.handleGoToCustomer(customer)}><AiOutlineEye /></button> <a className='btn blueButton' href={`update-customer/${customer.CustomerNo}`}><MdEdit /></a></td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}